var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnthropic = function SvgAnthropic(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    viewBox: "0 0 24 24",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Anthropic")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.827 3.52h3.603L24 20h-3.603l-6.57-16.48zm-7.258 0h3.767L16.906 20h-3.674l-1.343-3.461H5.017l-1.344 3.46H0L6.57 3.522zm4.132 9.959L8.453 7.687 6.205 13.48H10.7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnthropic);
export { ForwardRef as ReactComponent };